import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BLACK, Button, DynamicSvg, GridCol, GridContainer, GridRow, Typography, WHITE, isLastItem, tokens } from '@airtel/air-design-system';
import { Image, ImageBackground, View } from 'react-native';
import { getNativeSlideStyles } from './NativeSlideStyles';
export var NativeSlide = props => {
  var _props$item = props.item,
    item = _props$item === void 0 ? {} : _props$item,
    isLargeScreen = props.isLargeScreen,
    theme = props.theme,
    index = props.index,
    id = props.id,
    onUserAction = props.onUserAction,
    alignment = props.alignment;
  var nativeSlideStyles = getNativeSlideStyles(props, isLargeScreen);
  var imageUrl = item.imageUrl,
    logoUrl = item.logoUrl,
    _item$resizeMode = item.resizeMode,
    resizeMode = _item$resizeMode === void 0 ? 'cover' : _item$resizeMode,
    title = item.title,
    subtitle = item.subtitle,
    usp = item.usp,
    primaryCta = item.primaryCta,
    secondaryCta = item.secondaryCta,
    onPrimaryCtaPress = item.onPrimaryCtaPress,
    onsecondaryCtaPress = item.onsecondaryCtaPress;
  return _jsx(ImageBackground, Object.assign({
    imageStyle: {
      resizeMode
    },
    source: {
      uri: isLargeScreen ? imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.desktop : imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.mobile
    },
    style: nativeSlideStyles.nativeSlideBackground
  }, {
    children: _jsx(GridContainer, {
      children: _jsxs(GridRow, Object.assign({
        style: nativeSlideStyles.nativeSlideContent,
        noMargin: true
      }, {
        children: [!!logoUrl && _jsx(GridCol, Object.assign({
          noGutter: true,
          style: alignment === 'center' && nativeSlideStyles.alignCenter
        }, {
          children: _jsx(Image, {
            style: nativeSlideStyles.nativeSlideLogo,
            source: {
              uri: logoUrl
            }
          })
        })), !!title && _jsx(GridCol, Object.assign({
          noGutter: true,
          style: alignment === 'center' && nativeSlideStyles.alignCenter
        }, {
          children: _jsx(Typography, {
            text: title,
            type: isLargeScreen ? 'h4-bold' : 'body-para-xl-bold',
            theme: theme,
            style: nativeSlideStyles.nativeSlideTitle
          })
        })), !!subtitle && !usp && _jsx(GridCol, Object.assign({
          noGutter: true,
          style: alignment === 'center' && nativeSlideStyles.alignCenter
        }, {
          children: _jsx(Typography, {
            text: subtitle,
            type: isLargeScreen ? 'body-para-sm' : 'body-para-xs',
            theme: theme,
            style: nativeSlideStyles.nativeSlideSubtitle
          })
        })), !!(usp === null || usp === void 0 ? void 0 : usp.length) && _jsx(GridCol, Object.assign({
          noGutter: true,
          style: alignment === 'center' && nativeSlideStyles.alignCenter
        }, {
          children: _jsx(View, Object.assign({
            style: nativeSlideStyles.nativeSlideUspContainer
          }, {
            children: usp === null || usp === void 0 ? void 0 : usp.map((uspItem, index) => {
              return _jsxs(View, Object.assign({
                style: [nativeSlideStyles.nativeSlideUspItem, !isLastItem(usp, index) && nativeSlideStyles.nativeSlideUspItemGap]
              }, {
                children: [!!(uspItem === null || uspItem === void 0 ? void 0 : uspItem.icon) && _jsx(DynamicSvg, {
                  iconName: uspItem === null || uspItem === void 0 ? void 0 : uspItem.icon,
                  style: {
                    marginRight: tokens.spacing.SPACING_4
                  },
                  color: theme === 'dark' ? WHITE : BLACK,
                  fontSize: 14
                }), (uspItem === null || uspItem === void 0 ? void 0 : uspItem.text) && _jsx(Typography, {
                  text: uspItem.text,
                  type: "body-single-line-xs",
                  theme: theme
                })]
              }), "usp_" + index);
            })
          }))
        })), (!!(primaryCta === null || primaryCta === void 0 ? void 0 : primaryCta.title) || !!(secondaryCta === null || secondaryCta === void 0 ? void 0 : secondaryCta.title)) && _jsx(GridCol, Object.assign({
          noGutter: true,
          style: alignment === 'center' && nativeSlideStyles.alignCenter
        }, {
          children: _jsxs(View, Object.assign({
            style: nativeSlideStyles.nativeSlideButtonContainer
          }, {
            children: [!!(primaryCta === null || primaryCta === void 0 ? void 0 : primaryCta.title) && _jsx(Button, {
              style: nativeSlideStyles.nativeSlidePrimaryCta,
              size: "sm",
              buttonType: primaryCta.buttonType || 'primary',
              theme: theme,
              title: primaryCta.title,
              onPress: () => onPrimaryCtaPress && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
                id
              }, onPrimaryCtaPress), {
                index,
                item
              }))
            }), !!(secondaryCta === null || secondaryCta === void 0 ? void 0 : secondaryCta.title) && _jsx(Button, {
              size: "sm",
              buttonType: secondaryCta.buttonType || 'tertiary',
              theme: theme,
              title: secondaryCta.title,
              onPress: () => onsecondaryCtaPress && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
                id
              }, onsecondaryCtaPress), {
                index,
                item
              }))
            })]
          }))
        }))]
      }))
    })
  }));
};